import cln from "classnames";
import React from "react";
import "./single-line-row.scss";

export const renderSingleLineRow = ({title, key, control: {control, onClick}, path, hasError, isRequired, showErrors}) => (
    <div className={cln("form-row single-line-row", {"has-error": showErrors && hasError})} key={key} data-path={path.join(".")}>
        <div className="control" onClick={onClick}>
            {control}
        </div>
        <div className="label" onClick={onClick}>
            {title}

            {isRequired && "*"}
        </div>
    </div>
);
